import React from "react";
import { DoubleRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const quoteStatusDraft = "Draft";
const quoteStatusPending = "Pending";
const quoteStatusAccepted = "Accepted";
const quoteStatusRejected = "Rejected";

export const quoteStatus = [
    /*
    {
        value: quoteStatusDraft,
        key: quoteStatusDraft,
        name: quoteStatusDraft,
        text: quoteStatusDraft,

        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: false,
    },
    */
    {
        value: quoteStatusPending,
        key: quoteStatusPending,
        name: quoteStatusPending,
        text: quoteStatusPending,

        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: quoteStatusAccepted,
        key: quoteStatusAccepted,
        name: quoteStatusAccepted,
        text: quoteStatusAccepted,

        color: "#108ee9",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: quoteStatusRejected,
        key: quoteStatusRejected,
        name: quoteStatusRejected,
        text: quoteStatusRejected,
        color: "#cb6252",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
];

export const isFinalStatus = (status) => {
    if (status == quoteStatusAccepted || status == quoteStatusRejected) {
        return true;
    }
    return false;
};
